
if(!WebGiViewerSettings)
    WebGiViewerSettings = {
        viewer_version: "0.5.53",
        environment_map: ""
    }
if(!customElements.get('model-viewer-webgi')){
    const viewerScript = document.createElement('script');
    viewerScript.setAttribute('src',
        WebGiViewerSettings.viewer_version.includes('/') ? WebGiViewerSettings.viewer_version : // assume URL
            'https://dist.pixotronics.com/webgi/runtime/viewer-'+WebGiViewerSettings.viewer_version+'.js'
    );
    document.head.appendChild(viewerScript);
    let globalViewer = null; // to make sure we use only 1 viewer and canvas on a page, todo: fix later for proper multiple viewer support.

    class ModelViewerWebGi extends HTMLElement{
        constructor() {
            super();
            const container = document.createElement('div')
            this.container = container
            this.container.style.width = "100%"
            this.container.style.height = "100%"
            this.appendChild(container)

            // const poster = this.getAttribute('poster')
            // if(poster){
            //     const posterImg = document.createElement('img')
            //     posterImg.setAttribute('src', poster)
            //     posterImg.style.width = "100%"
            //     posterImg.style.height = "100%"
            //     posterImg.style.zIndex = "100"
            //     container.appendChild(posterImg)
            //     this.posterImg = posterImg
            // }
            this.modelLoaded = false;

            this.initialize()
        }

        doOnLoad(fn){
            if(this.modelLoaded) fn()
            this.onLoad = fn;
        }

        async initialize(){
            if(globalViewer) return;
            globalViewer = 1;
            this.viewer = await setupCoreWebGiViewer({container: this.container}, {importPopup: false, depthTonemap: true})
            globalViewer = this.viewer;
            this.viewer.canvas.style.width = "100%"
            this.viewer.canvas.style.height = "100%"
            const src = this.getAttribute('src')
            this.viewer.renderer.displayCanvasScaling = Math.min(window.devicePixelRatio, 1.5);
            const manager = this.viewer.getManager()
            let envMapPromise = null
            if(WebGiViewerSettings.environment_map && WebGiViewerSettings.environment_map.length){
                envMapPromise = manager.importer.importSinglePath(WebGiViewerSettings.environment_map)
            }
            const modelPromise = manager.addFromPath(src)
            const [model, envMap] = await Promise.all([modelPromise, envMapPromise])
            if(envMap) this.viewer.scene.setEnvironment(envMap)

            const controls = this.viewer.scene.activeCamera.controls
            if(controls){
                controls.enableDamping = true;
            }
            this.modelLoaded = true
            timeout(250).then(()=>{
                if(this.onLoad) this.onLoad()
            })
            // await timeout(250)


            window.addEventListener('shopify_model_viewer_ui_toggle_play', async (evt) => {
                this.parentElement.querySelector('.shopify-model-viewer-ui__controls-overlay').style.display = 'none';
                if (!(controls && controls.enabled)) return;
                const rotateIntensity = -1;
                controls.autoRotate = true;
                await timeout(1500)
                controls.autoRotateSpeed *= -1;
                await timeout(1500)
                controls.autoRotate = false;
                controls.autoRotateSpeed *= -1;
            });
            window.addEventListener('shopify_model_viewer_ui_toggle_pause', async (evt) => {
                this.parentElement.querySelector('.shopify-model-viewer-ui__controls-overlay').style.display = 'block';

                this.parentElement.querySelector('.shopify-model-viewer-ui__button--poster').onclick = ()=>{
                    window.dispatchEvent(new CustomEvent('shopify_model_viewer_ui_toggle_play'))
                }

            });


            // this.posterImg = this.parentElement.querySelector('.deferred-media__poster')
            // this.posterImg.style.display = 'none'
            // console.log(this.viewer)
        }

    }

    viewerScript.onload = function(){
        customElements.define('model-viewer-webgi', ModelViewerWebGi);
    }

}
